import React from 'react'
import classnames from 'classnames'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Pagination from 'react-js-pagination'
import qs from 'querystring'
import ObjectUtil from '@leverege/object-util'
import ArrayUtil from '@leverege/array-util'
import { Interface } from '@leverege/api-redux'
import { Text, Toast } from '@leverege/ui-elements'

import { Button } from 'react-bootstrap'
import DeviceItem from './DeviceItem'
import NoDevicesView from './NoDevicesView'
import { DeviceFactory } from '../../editors/device'
import PaginationSearch from '../utils/PaginationSearch'
import { DeviceActions, BreadcrumbActions, SystemActions, NotifyActions, BlueprintActions } from '../../actions'
import { List, SplitPane, Screen, YesNoDialog, Loading, LabelGroup, TextInput } from '../../views'

import style from './style.css'

class InterfaceDevicesTypeScreen extends React.Component {

  constructor( props, context ) {
    super( props, context );
    const { match : { params } } = this.props;
    this.interface = Interface.create( params.systemId, params.blueprintId )
    this.pager = new PaginationSearch( this, 'devices', ( props, opts ) => {
      const { dispatch, match : { params } } = this.props
      const options = { ...opts }

      options.blueprint = 'header'
      options.accessToken = true
      dispatch( Interface.create( params.systemId, params.blueprintId ).list( options ) )
    } )

    const qParsed = props.location.search && qs.parse( props.location.search.slice( 1 ) )

    this.state = { 
      selectedId : ( qParsed && qParsed.selected ) || null, 
      removeDevice : null, 
      search : this.pager.getSearchFrom( props )
    }
  }

  componentDidMount() {
    const { dispatch, match : { params } } = this.props
    dispatch( SystemActions.get( params.systemId ) )
    dispatch( BlueprintActions.listBlueprints( params.projectId ) )
    this.pager.loadPage( this.props )
  }

  componentDidUpdate( prevProps ) {

    const { system, dispatch } = this.props
    if ( ( system && system.id ) !== ( prevProps.system && prevProps.system.id ) ) {
      dispatch( BreadcrumbActions.setBreadcrumbs( 
        [ { name : 'Systems', link : `/project/${system.projectId}/system` }, { name : system.name } ] ) )
    }

    this.pager.loadIfNeeded( this.props )
  }

  onEvent = ( event, item ) => {
    const { dispatch, history, location } = this.props
    if ( event === 'select' ) {
      this.setState( { selectedId : item.id } );
    } else if ( event === DeviceItem.DUPLICATE_DEVICE_EVENT ) {
      const clone = { blueprintId : item.blueprintId,
                      name : `${item.name} copy`, 
                      simulated : !!item.simulated,
                      tags : ObjectUtil.copy( item.tags || null ),
                      metadata : ObjectUtil.copy( item.metadata || null ) }
      dispatch( DeviceActions.addDevice( item.systemId, clone, { accessToken : true } ) )
    } else if ( event === DeviceItem.REMOVE_EVENT ) {
      this.setState( { showRemoveDialog : true, removeDevice : item } )
    } else if ( event === DeviceItem.START_EVENT ) {
      dispatch( DeviceActions.startDevice( item ) )
    } else if ( event === DeviceItem.RESET_EVENT ) {
      dispatch( DeviceActions.resetDevice( item ) )
    } else if ( event === DeviceItem.PAUSE_EVENT ) {
      dispatch( DeviceActions.pauseDevice( item ) )
    } else if ( event === DeviceItem.OPEN_LOG_EVENT ) {
      dispatch( DeviceActions.logDevice( item ) )
    } else if ( event === DeviceItem.SIM_CONTROL_EVENT ) {
      history.push( `${location.pathname}/${item.id}/sim` )
    } else if ( event === DeviceItem.HISTORY_EVENT ) {
      history.push( `${location.pathname}/${item.id}/history` )
    }
  }

  onDeviceChange = ( event ) => {
    const { dispatch } = this.props
    const change = ObjectUtil.unflatten( {
      [event.path] : event.value
    }, '/' )
    dispatch( this.interface.update( event.target.id, change ) )
      .then( () => {
        Toast.success( 'Succesfully updated device' )
      } )
      .catch( ( err ) => {
        Toast.error( [ 'Error updating device', err.message ] )
      } )
  }

  onCreateDevice = ( ) => {
    const { dispatch, blueprint } = this.props
    const device = { blueprintId : blueprint.id, name : `${blueprint.name} Device` }
    dispatch( this.interface.create( device ) )
      .then( 
        () => {
          Toast.success( 'Device successfully created' )
        }
      )
      .catch(
        ( err ) => {
          Toast.error( [ 'Error creating device ', err.message ] )
        } 
      )
  }

  onPromptRemoveYes = async () => {
    const { dispatch } = this.props
    const { removeDevice } = this.state
    dispatch( this.interface.delete( removeDevice.id ) )
    dispatch( NotifyActions.success( 'Device successfuly deleted' ) )
    this.setState( { showRemoveDialog : false, removeDevice : null } )
  }

  onPromptRemoveNo = () => {
    this.setState( { showRemoveDialog : false, removeDevice : null } )
  }

  render() {
    const { networks, blueprints, blueprint, loading, match : { params : { projectId } } } = this.props
    const { removeDevice, showRemoveDialog, selectedId, search } = this.state
    const isSelected = item => ( item && item.id === selectedId )

    const page = this.pager.getPage()
    const total = this.pager.getTotal()
    const offset = this.pager.getStartFrom( this.props )
    const perPage = this.pager.getPerPage()

    const items = this.pager.getPageItems()
    
    const left = (
      <div className={style.left}>
        <List className={style.list}
          onEvent={this.onEvent}
          isSelected={isSelected}
          noItemsView={<NoDevicesView type={blueprint && blueprint.name} />}
          items={items}
          itemView={DeviceItem}
          itemProps={{ blueprints, networks }} />

        <div className={style.pagination}>
          <Pagination
            innerClass={classnames( 'pagination', style.innerPagination )}
            activePage={page}
            itemsCountPerPage={perPage}
            totalItemsCount={total}
            pageRangeDisplayed={5}
            onChange={this.pager.onPageChange} />
        </div>
        <Loading show={loading} message="Loading..." />
      </div>
    )
    let details = null
    if ( selectedId ) {
      // get the selected object
      const selected = ArrayUtil.find( items, 'id', selectedId )
      details = DeviceFactory.createEditor( selected, { networks, device : selected, onChange : this.onDeviceChange } );
    }
    const right = <div className={style.right}>{details}</div>
    return (
      <Screen className={style.screen}>
        <Screen.Header className={style.header}>
          <span>
            <Text variant="screenTitle" style={{ display : 'inline' }}>{`${blueprint?.name || 'Device'}s`}</Text> 
            { total ? (
              <span className={style.count}>
                {`(${offset} - ${Math.min( total, offset + perPage )} out of ${total})`}
              </span>
            ) : null }
          </span>
          <div style={{ display : 'inline-box', whiteSpace : 'nowrap' }}>
            <LabelGroup style={{ display : 'inline-flex', marginRight : 20 }}>
              <i className="fa fa-search" />
              <TextInput value={search}
                hint="search" 
                changeOnBlur={false}
                changeOnReturn
                onChange={this.pager.onSearchChange} />
            </LabelGroup>
            <Button bsStyle="primary"
              className="add-button" 
              onClick={this.onCreateDevice}> 
              <i className="fa fa-fw fa-circle-plus fa-lg" />
              New Device
            </Button>
          </div>
        </Screen.Header>
        <Screen.Content>
          <SplitPane style={{ height : '100%' }} left={left} right={right} />
        </Screen.Content>

        <YesNoDialog show={showRemoveDialog} 
          title={`Remove ${removeDevice && removeDevice.name}?`}
          message={<div>Are you sure you want to delete the device?</div>}
          onYes={this.onPromptRemoveYes}
          onNo={this.onPromptRemoveNo} />
        
      </Screen>
    );
  }
} 

export default withRouter( connect(
  ( state, props ) => {
    const { match : { params } } = props
    return {
      devices : Interface.create( params.systemId, params.blueprintId ).getList( state, { getAll : true } ) || {},
      loading : Interface.create( params.systemId, params.blueprintId ).isLoading( state ),
      blueprints : state.blueprints,
      blueprint : state.blueprints.index[params.blueprintId],
      networks : state.networks,
      system : state.systems && state.systems.lookup && state.systems.lookup[params.systemId]
    }
  }
)( InterfaceDevicesTypeScreen ) )
